import { HTMLProps } from 'react';

import { string } from 'prop-types';

import { classMerge } from '@/utils/class-names';
import CheckIcon from '~/icons/Check.svg';

export interface CheckboxProps extends HTMLProps<HTMLInputElement> {
	/**
	 * Id for the checkbox
	 */
	id: string;
	/**
	 * Name for the checkbox
	 */
	name?: string;
}

const inputStyles = classMerge(
	'appearance-none aspect-square h-full rounded-sm peer',
	'bg-neutral-grey-4 transition-all group-hover:scale-[1.2] disabled:group-hover:scale-[1]'
);

const iconStyles = classMerge(
	'absolute top-[0.1em] left-[0.1em]',
	'opacity-0 peer-checked:opacity-100',
	'transition-all group-hover:scale-[1.2]'
);

/**
 * Checkbox Library Component
 */
export const Checkbox = ({
	className,
	id,
	name = id,
	children,
	disabled,
	...props
}: CheckboxProps) => {
	const wrapperStyles = classMerge(
		'cursor-pointer relative group h-[1.5em]',
		'inline-flex items-center gap-x-2 text-left',
		'text-neutral-grey font-body text-label-1 font-bold',
		disabled && 'pointer-events-none',
		className
	);

	return (
		<label className={wrapperStyles} htmlFor={id}>
			<input
				type="checkbox"
				name={name}
				id={id}
				className={inputStyles}
				disabled={disabled}
				{...props}
			/>
			<CheckIcon className={iconStyles} width="1.3em" height="1.3em" />

			{children}
		</label>
	);
};

Checkbox.propTypes = {
	name: string.isRequired,
	id: string.isRequired,
};
